import { LocaleCode } from '@nuklear9/i18n';
import { graphql, useStaticQuery } from 'gatsby';


export const useFooterTagCloud = (locale: LocaleCode): Array<{
  langcode: string;
  id: string;
  drupalId: string;
  path: string;
  title: string;
} | undefined> => {
  const data = useStaticQuery<FooterTagCloudQuery>(graphql`
    query FooterTagCloud {
      drupalSettings {
        footerTagCloud {
          translations {
            langcode
            id
            drupalId
            path
            title
          }
        }
      }
    }
  `);

  return data.drupalSettings?.footerTagCloud ? data.drupalSettings?.footerTagCloud
    .map((item) => {
      return item?.translations.find(
        (translation) => translation.langcode === locale,
      );
    }).filter(Boolean) : [];
};
